import { render, staticRenderFns } from "./guardarZona.vue?vue&type=template&id=9067525c&scoped=true"
import script from "./guardarZona.vue?vue&type=script&lang=js"
export * from "./guardarZona.vue?vue&type=script&lang=js"
import style0 from "./guardarZona.vue?vue&type=style&index=0&id=9067525c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9067525c",
  null
  
)

export default component.exports